import React, { Component } from 'react';
import logo from '../assets/logo.jpg';
import menu from '../assets/menu.png';


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { responsive: false }
  }
  render() {
    const { responsive } = this.state;
    return (
      <header className="site-header">
        <div className="header-logo-mobile">
          <a href="/">
            <img src={logo} alt="WKND Skateboards" />
          </a>
        </div>
        <div className={`navigation ${responsive ? 'responsive' : ''}`}>
          <div className={`${this.props.page === 'team' ? 'nav-active' : ''}`} >
            <a href="/" style={{ color: 'white' }}>TEAM</a>
          </div>
          <div>
            <a href="/">SHOP</a>
          </div>
          {/* <div className={`${this.props.page === 'team' ? 'nav-active' : ''}`}>
            <a href="/team">TEAM</a>
          </div> */}
          <div className="header-logo">
            <a href="/">
              <img src={logo} alt="WKND Skateboards" />
            </a>
          </div>
          <div className={`${this.props.page === 'video' ? 'nav-active' : ''}`}>
            <a href="/video">VIDEO</a>
          </div>
          <div className={`${this.props.page === 'resources' ? 'nav-active' : ''}`}>
            <a href="/resources">RESOURCES</a>
          </div>
          <a href={() => null} className="menu-icon" onClick={() => this.setState({ responsive: !this.state.responsive })}>
            <img src={menu} alt="menu" className="hamburger" />
          </a>
        </div>
      </header >
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js